import DOMPurify from 'dompurify';

const textArea = document.querySelectorAll('.character-counter-input')

// account for multiple text areas on a page
textArea.forEach(input => {
  input.addEventListener('input', e => {
    if (input.hasAttribute('maxlength')) {

      const target = e.target
      // Count the current number of characters
      const currentLength = target.value.length
      // Get the `maxlength` attribute
      const maxLength = parseInt(target.getAttribute('maxlength'), 10)

      const characterCounter = `${currentLength}/${maxLength}`
      target.nextElementSibling.innerHTML = DOMPurify.sanitize(characterCounter)
    }
  })
})